import { render } from "./FeaturedProduct.vue?vue&type=template&id=09ebd058"
import script from "./FeaturedProduct.vue?vue&type=script&lang=js"
export * from "./FeaturedProduct.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__